var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSneakArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 30,
    viewBox: "0 0 16 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 109",
    d: "M13.4362 1.24686C13.6207 0.726313 14.1923 0.453924 14.7128 0.638458C15.2334 0.822993 15.5058 1.39457 15.3212 1.91511L13.4362 1.24686ZM7.30027 29.2109C6.84155 29.5184 6.22036 29.3959 5.9128 28.9372L0.90088 21.4618C0.593324 21.0031 0.715869 20.3819 1.17459 20.0743C1.63332 19.7668 2.25451 19.8893 2.56207 20.3481L7.01711 26.9928L13.6618 22.5378C14.1206 22.2302 14.7418 22.3528 15.0493 22.8115C15.3569 23.2702 15.2343 23.8914 14.7756 24.199L7.30027 29.2109ZM15.3212 1.91511C12.0444 11.1587 10.1043 16.5105 7.72449 28.5738L5.7623 28.1867C8.17053 15.9792 10.1492 10.5189 13.4362 1.24686L15.3212 1.91511Z",
    fill: "#99A943"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSneakArrow);
export default __webpack_public_path__ + "static/media/sneak-arrow.0fa41cb9be84a22bb5a1c9532d6bacdf.svg";
export { ForwardRef as ReactComponent };